import { DrawingService } from './DrawingService';
import { ShapeService } from './ShapeService';
import { LayerService } from './LayerService';
import { CurrentDatasetService } from './CurrentDatasetService';
import { PointCloudConfigService } from './PointCloudConfigService';
import { CropService } from './CropService';
import { NavigationModeService } from './NavigationModeService';
import { RestoreHelperService } from './RestoreHelperService';

export class PPAppServices {
    public drawingService;
    public shapeService;
    public layerService;
    public currentDatasetService;
    public pointCloudConfigService;
    public cropService;
    public navigationModeService;
    public restoreHelperService;

    constructor() {
        this.drawingService = new DrawingService(); // managing drawing objects
        this.shapeService = new ShapeService(); // managing shape objects
        this.layerService = new LayerService(); // managing layers
        this.currentDatasetService = new CurrentDatasetService(); // managing current dataset
        this.pointCloudConfigService = new PointCloudConfigService(); // managing point parameters (size, shape...)
        this.cropService = new CropService(); // managing crop objects
        this.navigationModeService = new NavigationModeService(); // managing navigation mode
        this.restoreHelperService = new RestoreHelperService(); // snapshot restore helper service
    }
}
